export default "__VITE_ASSET__BVy1HClb__"